import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $earnBlockTitle1: String,
    $earnBlockTitle1_en: String,
    $earnBlockTitle1_fr: String,
    $earnBlockTitle1_it: String,
    $earnBlockTitle1_pt: String,
    $earnBlockContent1: String,
    $earnBlockContent1_en: String,
    $earnBlockContent1_fr: String,
    $earnBlockContent1_it: String,
    $earnBlockContent1_pt: String
) {
  updateWhyHostPage (
    earnBlockTitle1: $earnBlockTitle1,
    earnBlockTitle1_en: $earnBlockTitle1_en,
    earnBlockTitle1_fr: $earnBlockTitle1_fr,
    earnBlockTitle1_it: $earnBlockTitle1_it,
    earnBlockTitle1_pt: $earnBlockTitle1_pt,
    earnBlockContent1: $earnBlockContent1,
    earnBlockContent1_en: $earnBlockContent1_en,
    earnBlockContent1_fr: $earnBlockContent1_fr,
    earnBlockContent1_it: $earnBlockContent1_it,
    earnBlockContent1_pt: $earnBlockContent1_pt
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
